import React, { useEffect, useMemo, useState } from 'react';
import { statesContext } from './context';

export const StatesProvider = ({ children }: React.PropsWithChildren<{}>) => {
	const [isOnline, setIsOnline] = useState<boolean>(window.navigator.onLine);
	useEffect(() => {
		window.addEventListener('online', () => setIsOnline(true));
		window.addEventListener('offline', () => setIsOnline(false));
	}, []);

	const [error, setError] = useState<Error>();

	const contextValue = useMemo(
		() => ({
			isOnline,
			error,
			setError,
		}),
		[isOnline, error],
	);

	return (
		<statesContext.Provider value={contextValue}>
			{children}
		</statesContext.Provider>
	);
};
